import { render, staticRenderFns } from "./CfopRegraForm.vue?vue&type=template&id=68659928"
import script from "./CfopRegraForm.vue?vue&type=script&lang=js"
export * from "./CfopRegraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports